import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function PasswordDialog({ open, onClose }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated"); setCur(""); setNext(""); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-brand-bg max-w-sm" data-testid="password-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-tight text-left">Change Password</DialogTitle>
          <DialogDescription className="sr-only">Update your account password</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label className="text-sm font-semibold">Current Password</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="border-brand-line" data-testid="pw-current" /></div>
          <div className="space-y-1.5"><Label className="text-sm font-semibold">New Password</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="border-brand-line" data-testid="pw-new" /></div>
        </div>
        <DialogFooter><Button onClick={save} disabled={busy || !cur || !next} data-testid="pw-save" className="bg-brand-primary hover:bg-brand-primary-hover text-white rounded-sm w-full">Update Password</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
